<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.update_lightspeed_config' | translate}}</div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_register' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_register_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-shopping-basket"></i></span>
        <p-dropdown [options]="registers" [(ngModel)]="config.registerID"
          placeholder="{{'onboarding.select_register' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_tax' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_tax_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-money"></i></span>
        <p-dropdown [options]="taxes" [(ngModel)]="config.taxID" placeholder="{{'onboarding.select_tax' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_user' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_user_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-user"></i></span>
        <p-dropdown [options]="users" [(ngModel)]="config.employeeID"
          placeholder="{{'onboarding.select_user' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_shop' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="shops" [(ngModel)]="config.shopID"
          placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_payment_type' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_payment_type_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="paymentTypes" [(ngModel)]="config.paymentTypeID"
          placeholder="{{'onboarding.select_payment_type' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="canDoQBPSearch">
    <div class="col-md-4 label">
      {{'onboarding.select_qbp_vendor' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_qbp_vendor_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="vendors" [(ngModel)]="config.qbpVendorID"
          placeholder="{{'onboarding.select_qbp_vendor' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="canDoHLCSearch">
    <div class="col-md-4 label">
      {{'onboarding.select_hlc_vendor' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_hlc_vendor_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="vendors" [(ngModel)]="config.hlcVendorID"
          placeholder="{{'onboarding.select_hlc_vendor' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8" *ngIf="canDoJBISearch">
    <div class="col-md-4 label">
      {{'onboarding.select_jbi_vendor' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_jbi_vendor_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="vendors" [(ngModel)]="config.jbiVendorID"
          placeholder="{{'onboarding.select_jbi_vendor' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.use_workorders_for_workshop' | translate}}:
      <span class="help fa hubtiger-tooltip"
        pTooltip="{{'onboarding.use_workorders_for_workshop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <p-inputSwitch [(ngModel)]="config.useWorkOrders"></p-inputSwitch>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.allow_sku_creation_from_job_card' | translate}}:
      <span class="help fa hubtiger-tooltip"
        pTooltip="{{'onboarding.allow_sku_creation_from_job_card_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <p-inputSwitch [(ngModel)]="config.allowSKUCreationFromJobCard"></p-inputSwitch>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;" (click)="updateConfig()"
        [disabled]="busy || !config.registerID || !config.employeeID || !config.taxID || !config.shopID">{{ busy ?
        ('onboarding.button.please_wait' | translate) : (config.registerID && config.employeeID && config.taxID &&
        config.shopID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' |
        translate)}}</button>
    </div>
  </div>

  <div *ngIf="technicians && technicians.length > 0 && isWorkshop">
    <div class="sub-header margin-top-16">
      {{ "bikeshop.shop_profile.pos-integration.technichan_linking" | translate }}
    </div>
    <div><small>{{ "bikeshop.shop_profile.pos-integration.technichan_linking_info" | translate }}</small></div>
    <div *ngFor="let technician of technicians" class="row margin-top-8">
      <div class="col-md-4 label">
        {{technician.Firstname}} {{technician.Surname}}
      </div>
      <div class="col-md-8">
        <p-dropdown [options]="users" [(ngModel)]="technician.POSEmployeeID" [showClear]="true"
          placeholder="{{ 'bikeshop.shop_profile.pos-integration.link_technician_to_pos_employee' | translate }}">
        </p-dropdown>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-8 label"></div>
      <div class="col-md-4">
        <button type="submit" class="iso-round-button" style="float: right;" (click)="updateTechnicians()"
          [disabled]="busyTechnicians">{{ busy ? ('onboarding.button.please_wait' | translate) :
          ('bikeshop.shop_profile.pos-integration.updated_linked_technicians' | translate) }}</button>
      </div>
    </div>
  </div>


</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="registers" [(ngModel)]="config.registerID"
          placeholder="{{'onboarding.select_register' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_register' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_register_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="taxes" [(ngModel)]="config.taxID" placeholder="{{'onboarding.select_tax' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_tax' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_tax_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="users" [(ngModel)]="config.employeeID"
          placeholder="{{'onboarding.select_user' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_user' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_user_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="shops" [(ngModel)]="config.shopID"
          placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_shop' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button" style="float: right;" (click)="updateConfig()"
        [disabled]="busy || !config.registerID || !config.employeeID || !config.taxID || !config.shopID">{{ busy ?
        ('onboarding.button.please_wait' | translate) : (config.registerID && config.employeeID && config.taxID &&
        config.shopID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' |
        translate)}}</button>
    </div>
  </div>
</div>


<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>